import dayjs from 'dayjs';
import { PatientCreditCard } from '@qmd-types/patient';
import { cn, CreditCardIcon, Paragraph } from '@quickmd-llc/design-system';

interface Props {
  creditCard: PatientCreditCard;
  selectedId: string;
  handleSelectCard: (creditCard: PatientCreditCard) => void;
}

export default function CreditCardItem({
  creditCard,
  selectedId,
  handleSelectCard,
}: Props): JSX.Element {
  const isExpired = dayjs(creditCard.expiry, 'YYYY-MM').isBefore(dayjs());
  function onClick() {
    if (!isExpired) handleSelectCard(creditCard);
  }
  return (
    <div className={cn({ 'cursor-pointer': !isExpired })} onClick={onClick}>
      <div className="flex flex-row justify-between rounded-lg bg-white p-4">
        <div className="flex h-auto flex-row gap-2 self-center">
          <CreditCardIcon
            type={creditCard.type}
            size="lg"
            className="text-text-dark"
          />
          <Paragraph
            size="sm"
            className={cn('font-semibold text-text-dark', {
              '!text-text-error': isExpired,
            })}
          >
            {creditCard.number.slice(4)}
          </Paragraph>
          <Paragraph
            size="xs"
            className={cn('self-center text-neutral-70', {
              '!text-text-error': isExpired,
            })}
          >
            {dayjs(creditCard.expiry, 'YYYY-MM').format('MM/YY')}
          </Paragraph>
        </div>
        {(isExpired || creditCard.id === selectedId) && (
          <Paragraph
            size="sm"
            className={cn('font-semibold text-text-dark', {
              '!text-text-error': isExpired,
              '!text-costal-blue-50': !isExpired,
            })}
          >
            {isExpired ? 'Expired' : 'Selected'}
          </Paragraph>
        )}
      </div>
    </div>
  );
}
